import React, { useState, useEffect, useRef, useId, useMemo } from 'react';
import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";
import { Typography } from '@mui/material';
import Progress from '../item/progress'

import { FONT_COLOR } from '../const/general'

export default function Bar(props) {

    const [categoryDates, setCategoryDates] = useState([]);
    const [h1Data, setH1Data] = useState([]);
    const [seriesMax, setSeriesMax] = useState(props.limitVal + 1);
    const [isNoData, setIsNoData] = useState(false);

    // チャートごとの一意のキー
    const chartId = useId();

    const aryMax = function (a, b) { return Math.max(a, b); }

    // チャート情報を格納
    const setChartData = (date_ary, h1) => {

        setCategoryDates(date_ary);
        setH1Data(h1);
        if (h1.length > 0) {
            // 土砂災害発生リスク、最大値を取得
            setSeriesMax(props.limitVal + 1)
            if (h1.length > 0 && h1.reduce(aryMax) > props.limitVal) {
                setSeriesMax(h1.reduce(aryMax))
            }
        }
    }

    // ローディング終了
    const loadingEnd = () => {
        props.setReady(prev => {
            const updated = { ...prev };
            props.isReadyKey.forEach(key => {
                if (key in updated) {
                    updated[key] = true;
                }
            });
            return updated;
        });
    }
    // スライダーにより選択されている時刻を青色表示（色は仮）
    const labelColors = categoryDates.map((cate, i) =>
        i === props.chooseNum ? '#0000FF' : FONT_COLOR
      );

    // データ更新が完了したらローディング終了
    useEffect(() => {
        loadingEnd()
    }, [h1Data]);

    useEffect(() => {
        // if (isEqual(h1Data, props.chartData)) {
        //     // 旧データと新データが完全一致の場合はローディング終了
        //     loadingEnd()
        //     return
        // }
        if (props.dateArray === null
            || props.chartData === null) {
            setIsNoData(true)
            loadingEnd()
            return
        }
        if (props.dateArray && props.dateArray.length > 0
            && props.chartData && props.chartData.length > 0) {
            setChartData(props.dateArray, props.chartData)
        }
        setIsNoData(false)
        loadingEnd()
    }, [props.dateArray, props.chartData]);

    useEffect(() => {
        if (props.dateArray === null
            || props.chartData === null) {
            setIsNoData(true)
            loadingEnd()
            return
        }
        if (props.dateArray && props.dateArray.length > 0
            && props.chartData && props.chartData.length > 0) {
            setChartData(props.dateArray, props.chartData)
        }
        setIsNoData(false)
        loadingEnd()

        return () => {
            ApexCharts.exec(chartId, 'destroy'); // 明示的に破棄
        };
    }, []);


    const series = useMemo(() => {
        return [
            {
                name: props.dataName,
                type: 'column',
                data: h1Data
            },
        ];
    }, [h1Data]);

    const options = useMemo(() => ({

        chart: {
            id: chartId,
            toolbar: {
                show: false,
                offsetY: 0
            },
            // height: 350,
            type: 'bar',
            stacked: false
        },
        // ポイントの数値表示
        dataLabels: {
            enabled: true,
            enabledOnSeries: [1],
            offsetY: -10,
            style: {
                fontSize: '8px',
                colors: ['white']
            }
        },
        colors: [
            '#5c9fed'
        ],
        stroke: {
            width: [0],
            colors: ['transparent']
        },
        annotations: {
            yaxis:  props.annotations,
            xaxis: [
                {
                    x: categoryDates[12],
                    borderColor: '#0000FF',
                    borderWidth: 1,
                    strokeDashArray: 4,
                    label: {
                        show: false,
                    }
                }
            ],
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
                borderRadiusApplication: 'around',
            }
        },
        xaxis: {
            categories: categoryDates,
            labels: {
                rotate: -45,
                rotateAlways: true,
                style: {
                    colors: labelColors,
                    fontSize: '10px',
                },
            },
        },
        yaxis:
        {
            min: 0,     // 最小値
            max: seriesMax,   // 最大値
            seriesName: props.dataName,
            axisTicks: {
                show: false
            },
            axisBorder: {
                show: false,
            },
            labels: {
                show: false,
            },
            lines: {
                show: false
            },
        },
        tooltip: {
            shared: false,
            intersect: true,
            x: {
                show: false
            },
            y: {
                formatter: function (val) {
                    return parseFloat(val).toFixed(0); // ← 小数なしを明示的に指定
                }
            }
        },
        grid: {
            show: false, // 全体の罫線を消す
            padding: {
                left: 22,
                right: 12,
                top: -10,
                bottom: -13
            }
        },
        legend: {
            show: false,
            height: 0,
        }
    }), [categoryDates, seriesMax, props.annotations, props.dataName, labelColors]);

    // チャートのデータが更新されtら強制再描画
    useEffect(() => {
        if (series && series.length > 0) {
            ApexCharts.exec(chartId,"updateSeries", series);
        }
    }, [series]);

    return (
        <>
            {!props.isReadyFlg ?
                <Progress />
                // <ChartSkeleton />
                :
                isNoData ?
                    <Typography
                        sx={{
                            fontSize: '0.75rem',
                            fontWeight: 'bold',
                            color: 'white',
                        }}
                    >
                        対象データがありません
                    </Typography>
                    :
                    <Chart
                        options={options}
                        series={series}
                        type="bar"
                        height="100%"
                        width="100%"
                        style={{ visibility: props.isReadyFlg ? 'visible' : 'hidden' }}
                    />
            }
        </>
    );
}
